import { useEffect } from 'react';
import { ArrowRightIcon, ExternalLinkIcon, PhoneIcon } from 'lucide-react';
import { business, routes } from '../data/site';
import { SiteLink } from '../components/SiteLink';
import { AvailableInventory } from '../components/AvailableInventory';
const TITLE = 'Available Spas | Pegasus Spas Brooklyn, MI';
const DESCRIPTION = 'Browse models, colors and availability from the Pegasus Spas list. Confirm current availability and delivery timing with us.';
const CANONICAL = 'https://www.pegasus-spas.com/hot-tubs/available-spas';
const SHEET_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTdvOREzeAFJYJ1Wxye7hZrD5U7jurvbzD5Jz21iQm5IPCiPj1PU6uYrSSUu00lVUhqfKxpZK0cM2G4/pubhtml?gid=712112742&single=true&widget=true&headers=false';
const relatedLinks = [{
  label: 'Sundance Spas',
  href: routes.sundance
}, {
  label: 'Viking Spas',
  href: routes.viking
}, {
  label: 'Certified Pre-Owned',
  href: routes.preOwned
}, {
  label: 'Financing',
  href: routes.financing
}, {
  label: 'Specials',
  href: routes.specials
}];
function upsertMeta(name: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function AvailableSpasPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = TITLE;
    upsertMeta('description', DESCRIPTION);
    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', CANONICAL);
  }, []);
  return <main data-id="element-618" data-mp="2oe08v51xgmrs">
      <section aria-labelledby="available-h1" className="w-full bg-water" data-id="element-619" data-mp="2oejogf43uz2n">
        <div className="mx-auto max-w-container px-5 py-10 sm:px-8 lg:py-12" data-id="element-620" data-mp="2jenn6nmsllqs">
          <p className="text-[14px] font-bold uppercase text-pegasus-blue" data-id="element-621" data-mp="2jgqh3ir2fz0s">Current Availability</p>
          <h1 id="available-h1" className="mt-2 font-display text-h2-mobile font-semibold text-ink lg:text-[40px] lg:leading-[48px]" data-id="element-622" data-mp="1bd3xfs2ux2gg">
            Available Spas
          </h1>
          <p className="mt-4 max-w-3xl text-body text-ink/80 sm:text-body-lg" data-id="element-623" data-mp="16flpo50ksta1">
            Find a spa by model, brand, color or location. Availability changes, so call or text
            us to confirm the exact spa and delivery timing before making the drive.
          </p>
          <a href={business.phoneHref} className="mt-6 inline-flex min-h-[48px] items-center gap-2 whitespace-nowrap rounded-btn bg-pegasus-magenta px-6 text-[16px] font-bold text-white transition-colors duration-150 ease-out hover:bg-[#bb2f83]" data-id="element-624" data-mp="wjsgmvm2fhx0">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-625" data-mp="8svegak2nyyy" />
            Call or Text {business.phone}
          </a>
        </div>
      </section>

      <section aria-label="Live available spas list" className="w-full bg-white" data-id="element-626" data-mp="3qa92gjcphggp">
        <div className="mx-auto max-w-container px-5 pb-12 pt-8 sm:px-8 lg:pb-16" data-id="element-627" data-mp="3m972g0ayt0do">
          <AvailableInventory data-id="element-628" data-mp="3mb9yb0ystnqb" />

        </div>
      </section>

      <section aria-label="Related pages" className="w-full border-t border-ink/10 bg-white" data-id="element-629" data-mp="44dk7uaqyfeq">
        <div className="mx-auto max-w-container px-5 py-6 sm:px-8" data-id="element-630" data-mp="3v8u6yuyzqmay">
          <ul className="flex flex-col gap-x-8 gap-y-1 sm:flex-row sm:flex-wrap sm:items-center" data-id="element-631" data-mp="d40ja9g0794m">
            {relatedLinks.map(link => <li key={link.label} data-id="element-632" data-mp="925lvg171fw4">
                <SiteLink to={link.href} className="inline-flex min-h-[44px] items-center gap-1.5 text-[16px] font-medium text-pegasus-blue underline decoration-pegasus-blue/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-pegasus-magenta hover:decoration-pegasus-magenta" data-id="element-633" data-mp="mu2b9cbh9bot">
                  {link.label}
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-634" data-mp="rr26stapaw1o" />
                </SiteLink>
              </li>)}
          </ul>
        </div>
      </section>
    </main>;
}